import { render, staticRenderFns } from "./by-person.vue?vue&type=template&id=1c8c37af&scoped=true"
import script from "./by-person.vue?vue&type=script&lang=ts"
export * from "./by-person.vue?vue&type=script&lang=ts"
import style0 from "./by-person.vue?vue&type=style&index=0&id=1c8c37af&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8c37af",
  null
  
)

export default component.exports